import { render, staticRenderFns } from "./TextAreaModal.vue?vue&type=template&id=bf7c9282&scoped=true"
import script from "./TextAreaModal.vue?vue&type=script&lang=ts"
export * from "./TextAreaModal.vue?vue&type=script&lang=ts"
import style0 from "./TextAreaModal.vue?vue&type=style&index=0&id=bf7c9282&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7c9282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf7c9282')) {
      api.createRecord('bf7c9282', component.options)
    } else {
      api.reload('bf7c9282', component.options)
    }
    module.hot.accept("./TextAreaModal.vue?vue&type=template&id=bf7c9282&scoped=true", function () {
      api.rerender('bf7c9282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TextAreaModal.vue"
export default component.exports